<template>
    <div>
        <el-row>
            <el-col>
                <h3 class="greenTitle">Seleccionar el estado de sus LPNs/órdenes:</h3>
                <h4>ORDENES DE LA RUTA {{ routeId }} EN TRANSITO</h4>
                <p>NOMBRE DE LA EMPRESA: {{ enterpriseName }}</p>
                <p>NOMBRE DEL CONDUCTOR: {{ driverName }}</p>
                <p>PATENTE: {{ plate }}</p>
                <el-alert
                    v-if="validationWarnings.length > 0"
                    class="mt-1"
                    type="warning"
                    :closable="false"
                    :title="validationWarnings.join(' ')"
                    show-icon />
            </el-col>
        </el-row>

        <el-divider border-style="dashed" />

        <div v-if="!sendRoute">
            <el-row>

                <el-col class="c-fr" :span="6">
                    <el-select
                        class="m-2"
                        placeholder="NUEVO ESTADO"
                        size="large"
                        v-model="massiveOption"
                        @change="massiveOptionChange">
                        <el-option label="Entregado" value="5000" />
                        <el-option label="Sin cambio" value="5001" />
                        <el-option
                            v-for="r in reasons"
                            :key="r.id"
                            :label="r.reason"
                            :value="r.id" />
                    </el-select>
                </el-col>
                <el-col class="c-fr" :span="6">
                    <h3>CAMBIAR MASIVAMENTE ESTADO</h3>
                </el-col>
            </el-row>

            <el-row>
                <el-table :data="this.orders" ref="routeTable">
                    <el-table-column label="SOC" prop="code" />
                    <el-table-column label="LPN" prop="lpn" />
                    <el-table-column label="ESTADO" prop="status" />
                    <el-table-column label="ACCIÓN">
                        <template #default="scope" style="padding-left:0">
                            <el-select
                                v-model="scope.row.action"
                                class="m-2"
                                placeholder="NUEVO ESTADO"
                                size="large">
                                <el-option selected label="Entregado" value="5000" />
                                <el-option label="Sin cambio" value="5001" />
                                <el-option
                                    v-for="r in reasons"
                                    :key="r.id"
                                    :label="r.reason"
                                    :value="r.id" />
                            </el-select>
                        </template>
                    </el-table-column>
                </el-table>

                <el-button v-on:click="confirmOrders" size="large" class="default right ml-1 mt-1">
                    CONFIRMAR
                </el-button>

                <el-button v-on:click="back" size="large" class=" ml-1 mt-1">
                    REGRESAR
                </el-button>

            </el-row>
        </div>


        <el-row v-else>
            <p style="font-size: 2rem; color: #A0BE03;text-align: center;">
                <i class="el-icon-loading" style="margin-right: 5px;">
                </i>Enviando las ordenes
            </p>
        </el-row>


        <el-dialog title="Información" :visible.sync="dialogVisible">
            <span>{{ dialogMsg }}</span>
            <span slot="footer" class="dialog-footer">
                <el-button class="default" @click="dialogVisible = false">Cerrar</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>

import { apiRequest } from '@/backend/vue-axios/axios';


export default {
  name: 'route',
  components: {
  },
  props: {
    routeId: Number,
    enterpriseName: String,
    driverName: String,
    plate: String,
    orders: Array,
    reasons: Array,
    validationWarnings: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      massiveOption: '',
      dialogMsg: '',
      dialogVisible: false,
      sendRoute: false,
    };
  },
  methods: {
    massiveOptionChange(state) {
      this.orders.forEach((_, index) => {
        this.orders[index].action = state;
      });
    },
    confirmOrders(force = false) {
      const { orders, routeId } = this;
      const actionsValidate = ['5000', '5001']
        .concat(this.reasons.map(reason => String(reason.id)));
      const hasInvalidAction = this.orders
        .some(order => !actionsValidate.includes(String(order.action)));

      if (hasInvalidAction) {
        this.dialogMsg = 'Hay ordenes que no tienen acción seleccionada';
        this.dialogVisible = true;
        return;
      }

      if (!force && this.validationWarnings.length > 0) {
        this.$confirm(
          `${this.validationWarnings.join(' ')} ¿Quieres continuar?`,
          'Confirmar cambio de estado',
          {
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
            type: 'warning',
          },
        ).then(() => {
          this.confirmOrders(true);
        }).catch(() => {});
        return;
      }

      this.sendRoute = true;
      const requestBody = this.mappingOrderModelToOrderRequest(orders, routeId, force);
      apiRequest(
        {
          module: 'location',
          service: 'change_status',
          params: requestBody,
        },
      ).then((response) => {
        const responseBody = response.data;
        this.sendRoute = false;
        this.$emit('ordersSent', responseBody);
      }).catch((error) => {
        this.sendRoute = false;
        const message = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'No fue posible cambiar el estado.';

        if (!force) {
          this.$confirm(
            `${message} ¿Quieres continuar de todas formas?`,
            'Confirmar cambio de estado',
            {
              confirmButtonText: 'Continuar',
              cancelButtonText: 'Cancelar',
              type: 'warning',
            },
          ).then(() => {
            this.confirmOrders(true);
          }).catch(() => {});
          return;
        }

        this.$notify({
          type: 'info',
          title: 'Información',
          message,
        });
      });
    },
    back() {
      this.$emit('back');
    },
    mappingOrderModelToOrderRequest(orders, routeId, force) {
      const requestBody = {
        route_id: routeId,
        force,
        update_suborder: [],
      };
      orders.forEach((element) => {
        const action = String(element.action);
        let status = 0;
        let reasonId = 0;

        status = parseInt(action, 10);

        if (status !== 5000) {
          reasonId = parseInt(action, 10);
          status = 0;
        } else {
          status = 1;
        }

        if (action !== '5001') {
          requestBody.update_suborder.push({
            order_code: `${element.code}`,
            status,
            reasonId,
          });
        }
      });
      return requestBody;
    },
  },
};
</script>

<style>
.greenTitle {
    font-size: 15px;
    color: #AAD500;
    margin: 0;
    text-align: left;
    font-weight: 900;
    text-transform: uppercase;
    margin-bottom: 10px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}

.c-fr {
    float: right !important;
}

.right {
    float: right;
}

.mt-1 {
    margin-top: 0.50rem !important;
}
</style>
